/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-23 14:10:49
 */
import { defHttp } from "../utils/http/axios";

const Api = {
  getProject: "/cat/tasker/project/detail",
  getTaskItem: "/cat/tasker/project/task/detail",
  getFileBriefInfo: "/cat/tasker/project/file/brief",
  getFileSentences: "/cat/tasker/project/file/sentence/list",
  getTaskSentences: "/cat/tasker/project/task/sentence",

  //todo
  checkTick: "/cat/tasker/sentence/check",
  getSentenceStatusAndQA: "/cat/tasker/sentence/status",
  getSentenceLog: "/cat/tasker/sentence/log",
  getTMmatches: "/cat/tasker/sentence/tm",
  getMTMatches: "/cat/tasker/sentence/mt",
  getTBmatches: "/cat/tasker/sentence/tb",
  getPolishResult: "/cat/tasker/sentence/polish",
};

/**
 * get not read information
 * @returns
 */
export function getNotReadInfo() {
  return defHttp.get({ url: "/message/notRead" });
}

/**
 * query notice list
 * @param {*} searchForm
 * @returns
 */
export function fetchNotice(params) {
  return defHttp.post({url:"/message/list", params});
}

/**
 * set notice's state as read
 * @param {{type:Number}} dataForm
 * @returns
 */
export function setNoticeRead(params) {
  return defHttp.post({url:"/message/setRead", params});
}

/**
 * set all notices as read
 * @returns
 */
export function setAllNoticeRead() {
  return defHttp.post({url:"/message/setRead/all"});
}

/**
 * get newestData
 * @param {*} formData
 */
export function getRefreshInfo(params) {
  return defHttp.post({url:"/message/refresh", params});
}

/**
 *
 * @param {*} formData
 * @returns
 */
export function fetchSystemNotices(formData) {
  return post("/notice/system", formData);
}

/**
 *
 * @param {*} data
 * @returns
 */
export function editSystemNotice(data) {
  return post("/notice/system/edit", data);
}

/**
 *
 * @param {*} id
 * @returns
 */
export function delSystemNotice(id) {
  return post("/notice/system/del", { id });
}

/**
 *
 * @param {*} id
 * @returns
 */
export function sendSystemNotice(id) {
  return post("/notice/system/send", { id });
}
